import {
	applySnapshot,
	flow,
	getParent,
	Instance,
	SnapshotOut,
	types,
} from 'mobx-state-tree';

import { deleteModule, getModule, updateModule } from '@common/api/modules';
import Program from '@common/models/Programs/Program';
import { IModulesModel } from './Modules'; // eslint-disable-line import/no-cycle

const Module = types.model('Module', {
	id: types.identifierNumber,
	program_id: types.number,
	name: types.optional(types.string, ''),
	description: types.maybeNull(types.string),
	sort_id: types.optional(types.number, 0),
	is_final: types.optional(types.boolean, false),
	program: types.maybeNull(Program),
})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getModule(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			try {
				yield deleteModule(self.id);
				const parent = getParent<IModulesModel>(self, 2);
				parent.removeItem(self as IModuleModel);
			} catch (e) {
				console.error(e);
			}
		}),
		save: flow(function* (data) {
			self.loading = true;
			try {
				const result = yield updateModule(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Module;

export interface IModule extends SnapshotOut<typeof Module> {}
export interface IModuleModel extends Instance<typeof Module> {}
